<template>
  <div>
    <b-form-group :label="label" :label-class="required ? 'required' : ''">
      <div
        :class="['drop-zone', dragging ? 'drop-zone--over' : '']"
        @dragenter="dragging == true"
        @dragleave="dragging == false"
      >
        <span class="drop-zone__prompt"
          >فایل را کشیده و رها کنید یا اینجا کلیک کنید</span
        >

        <input
          type="file"
          ref="file"
          :accept="accept"
          class="drop-zone__input"
          :required="required ? 'required' : ''"
          v-on:change="select"
        />
      </div>
      <b-progress
        :value="progress"
        height="2rem"
        class="mt-2"
        :variant="uploadstatus"
        v-show="progress > 0"
      >
        <b-progress-bar :value="progress">
          <span
            v-if="
              progress > 0 &&
                uploadstatus != 'success' &&
                uploadstatus != 'danger'
            "
            >در حال آپلود: <strong>{{ progress }}</strong></span
          >
          <span v-else-if="uploadstatus == 'danger'"
            >آپلود با خطا مواجه شد</span
          >
          <span v-else-if="uploadstatus == 'success'"
            >آپلود با موفقیت به اتمام رسید</span
          >
        </b-progress-bar>
      </b-progress>
      <b-form-invalid-feedback id="input-1-live-feedback">
        {{ label }} ضروری است
      </b-form-invalid-feedback>
    </b-form-group>
    <div class="preview mb-2" v-if="internalValue != null">
      <div v-show="internalValue.filename">
        نام فایل : {{ internalValue.filename }}
      </div>
      <div v-show="internalValue.duration">
        مدت زمان : {{ internalValue.duration }}</div>
    </div>
  </div>
</template>

<script>
import JwtService from "@/core/services/jwt.service";
export default {
  name: "Rupload",

  watch: {
    chunks(n, o) {
      if (n.length > 0) {
        this.upload();
      }
    }
  },
  props: {
    value: {
      default: null
    },
    label: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    preview: {
      type: Boolean,
      default: true
    },
    accept: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dragging: false,
      file: "",
      filetype: "",
      chunks: [],
      uploaded: 0,
      uploadstatus: "primary",
      previewUrl: ""
    };
  },

  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    progress() {
      return Math.floor((this.uploaded * 100) / this.file.size);
    },
    formData() {
      let formData = new FormData();

      formData.set("is_last", this.chunks.length === 1);
      formData.set("file", this.chunks[0], `${this.file.name}.part`);

      return formData;
    },
    config() {
      return {
        method: "POST",
        data: this.formData,
        url: this.url,
        headers: {
          "Content-Type": "application/octet-stream",
          common: {
            Authorization: `Bearer ${JwtService.getToken()}`
          }
        },
        onUploadProgress: event => {
          this.uploaded += event.loaded;
        }
      };
    }
  },

  methods: {
    select(event) {
      const file = event.target.files.item(0);
      this.file = file;
      this.createChunks();
    },
    upload() {
      axios(this.config)
        .then(response => {
          this.chunks.shift();

          if (response.data.filename != null) {
            this.uploadstatus = "success";
          }
          this.$emit("input", response.data);
          this.internalValue = response.data;
        })
        .catch(error => {
          this.uploadstatus = "danger";
        });
    },
    createChunks() {
      let size = 10 * 1024 * 1024,
        chunks = Math.ceil(this.file.size / size);
      for (let i = 0; i < chunks; i++) {
        this.chunks.push(
          this.file.slice(
            i * size,
            Math.min(i * size + size, this.file.size),
            this.file.type
          )
        );
      }
    }
  }
};
</script>

<style lang="scss">
.drop-zone {
  width: 100%;
  min-height: 200px;
  padding: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  color: #999;
  border: 2px dashed #00953e;
  border-radius: 10px;
  position: relative;
}

.drop-zone--over {
  border-style: solid;
}

.drop-zone__input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.drop-zone__thumb {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  overflow: hidden;
  background-color: #999;
  background-size: cover;
  position: relative;
}

.drop-zone__thumb::after {
  content: attr(data-label);
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 5px 0;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.75);
  font-size: 14px;
  text-align: center;
}

.preview {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-around;
  .item {
    //  flex: 0 0 49%;
    //   width: 49%;
    //   height: 150px;
    img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }
}

.vcp-container {
  direction: ltr;
}
</style>
